<script>
  import { onMount, getContext } from "svelte";
  import { navigate, Link } from "svelte-routing";
  import {
    Input,
    Table,
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner
  } from "sveltestrap";
  import Icon from "svelte-awesome";
  import {
    filter as filterIcon,
    sort,
  } from "svelte-awesome/icons";

  import axios from "axios";
  import { addYears } from "date-fns";

  import DataSpinner from "../Spinner.svelte";
  import SucessPTO from "../containers/SucessPTOContainer.svelte";
  import NavbarSuccess from "../NavbarSuccess.svelte";
  import ColumnFilterModal from '../ColumnFilterModal.svelte';
  import ConfirmationDialog from '../ConfirmationDialog.svelte';

  let fetching = false;
  let data = [];

  let displayedData = [];
  let filteredFields = {};
  let sortStates = {};
  let columnFilterModal = { open: () => {} };

  let selectedRows = [];
  let isApproveInProgress = false;
  let isDeclineInProgress = false;
  $: hasSelectedRow = Object.keys(selectedRows).some(key => !!selectedRows[key]);

  let canApproveOrDecline = false;

  let isApproveConfirmOpen = false;
  let isApproveDone = false;
  let approveResponse = '';
  let isDeclineConfirmOpen = false;
  let isDeclineDone = false;
  let declineResponse = '';

  function fetchDataAsync() {
    const startDate = addYears(new Date(), -1).toISOString();
    const endDate = new Date().toISOString();
    selectedRows = {};

    return fetch('/authentication/GetUserDetails')
      .then(res => res.json())
      .then(res => {
        const user = res.Result;
        const contactId = user.ID;
        const teamId = user.Team;
        const isProjectManager = user.IsProjectManager;
        const isDirectManager = user.IsTeamLead;
        canApproveOrDecline = user.JobTitle === 'Director of Production';

        return axios
          .get(`/requestPTOapi/GetPendingPTOs?teamId=${teamId}&contactId=${contactId}&isProjectManager=${isProjectManager}&isDirectManager=${isDirectManager}`);
      })
      .then(function(res) {
        data = res.data.Result;
        displayedData = data;
      })
      .catch(function(err) {
        console.log(err);
      });
  }

  function DateAndHours() {
    listDate = [];
    listHours = [];
    startDate = startDate;

    var date = document.getElementsByName("date[]");

    for (var i = 0; i < date.length; i++) {
      listDate.push(date[i].value);
    }
    var hours = document.getElementsByName("hours[]");

    for (var i = 0; i < hours.length; i++) {
      if (hours[i].value != "") {
        listHours.push(hours[i].value);
      }
    }

    if (hours.length == listHours.length) {
      hoursFilledUp = true;
    } else {
      hoursFilledUp = false;
    }
  }

  function getDifDays() {
    listDateFormat = [];
    const start = new Date(startDate + " ");
    const end = new Date(endDate + " ");
    const difTime = end.getTime() - start.getTime();
    const arrdate = [];
    difDays = difTime / (1000 * 3600 * 24) + 1;
    for (var i = 0; i < difDays; i++) {
      if (i == 0) {
        listDateFormat.push(start.setDate(start.getDate()));
      } else {
        listDateFormat.push(start.setDate(start.getDate() + 1));
      }
    }

    console.log(listDateFormat);
    console.log(difDays);
  }

  function submit() {
    DateAndHours();
    loading = true;
    var bodyFormData = new FormData();
    bodyFormData.set("StartDate", startDate);
    bodyFormData.set("EndDate", endDate);
    bodyFormData.set("TimeOffType", timeOffType);
    bodyFormData.set("Date", listDate);
    bodyFormData.set("Hours", listHours);
    bodyFormData.set("Notes", notes);
    axios({
      method: "post",
      url: "/RequestPTOApi/SendRequest",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" }
    })
      .then(function(response) {
        loading = false;
        sucess = true;
      })
      .catch(function(response) {
        console.log(response);
      });
  }

  function updateFilters(field, value) {
    filteredFields = filteredFields || {};
    filteredFields[field] = value;
    filteredFields = filteredFields;
    displayedData = data.filter(filterData).sort((a, b) => compareFields(a, b, field));
  }

  function sortData(field) {
    sortStates[field] = !sortStates[field];
    displayedData = data.filter(filterData).sort((a, b) => compareFields(a, b, field));
  }

  function compareFields(a, b, fieldName) {
    // Use toUpperCase() to ignore character casing
    const lhs = `${a[fieldName]}`.toUpperCase();
    const rhs = `${b[fieldName]}`.toUpperCase();

    const comparison = lhs > rhs ? 1
      : lhs < rhs ? -1
      : 0;

    return sortStates[fieldName] ? comparison : comparison * -1;
  }

  function filterData(item) {
    let isMatch = true;

    for (const key in filteredFields) {
      if (filteredFields.hasOwnProperty(key)) {
        const searchTerm = (filteredFields[key] || '').toLowerCase();

        let fieldRawValue = '';
        switch (key) {
          default:
            fieldRawValue = item[key] || '';
            break;
        }

        const fieldValue = fieldRawValue.toString().toLowerCase();

        isMatch = isMatch && fieldValue.includes(searchTerm);
      }
    }

    return isMatch;
  }

  function showColumnFilterModal(field, value) {
    columnFilterModal.show(field, value, filteredFields[field]);
  }

  function GetDownloadUrl() {
    const teamStaffFilter = filter === 1 ? `teamid=${teamId}`
      : filter === 2 ? `staffid=${staffId}`
      : '';

    return `/requestPTOapi/GetPTOReport?startdate=${startDate}&enddate=${endDate}&${teamStaffFilter}&filter=${filter}`;
  }

  function confirmationDialogCancel() {
    toggleConfirmation();
  }

  function onApprove() {
    isApproveConfirmOpen = true;
  }

  async function onApproveConfirmed() {
    isApproveConfirmOpen = false;
    const selectedRowIds = Object.keys(selectedRows).filter(key => !!selectedRows[key]);
    const requestOptions = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ employeePtoIds: selectedRowIds }),
    };

    isApproveInProgress = true;
    const response = await fetch(`/ptoapproval/approveptos`, requestOptions);
    isApproveInProgress = false;

    const result = await response.json();

    approveResponse = result.Message;
    isApproveDone = true;

    fetchDataAsync();
  }

  function onDecline() {
    isDeclineConfirmOpen = true;
  }

  async function onDeclineConfirmed() {
    isDeclineConfirmOpen = false;
    const selectedRowIds = Object.keys(selectedRows).filter(key => !!selectedRows[key]);
    const requestOptions = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ employeePtoIds: selectedRowIds }),
    };

    isDeclineInProgress = true;
    const response = await fetch(`/ptoapproval/declineptos`, requestOptions);
    isDeclineInProgress = false;

    const result = await response.json();

    declineResponse = result.Message;
    isDeclineDone = true;

    fetchDataAsync();
  }

  function approveDeclineCompleted() {
    refreshData = true;
  }

</script>

<style>
  input {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
  }
  select {
    width: 50%;
    padding: 10px;
    border-radius: 5px;
  }
  .row {
    margin: 15px 0px;
  }
  button {
    padding: 10px 5px;
    border-radius: 5px;
    background-color: #3498db;
    color: white;
  }

  th {
    background-color: #223646;
    color: white;
  }
  .header-label {
    cursor: pointer;
  }

  .request-pto-list {
    width: 100%;
    overflow: auto;
    padding: 0px 30px;
  }

  .request-pto-list th {
    background-color: #223646;
    color: white;
  }

  .request-row {
    display: flex;
  }
  .res-view-title {
    display: none;
  }
  @media (max-width: 768px) {
    .request-row {
      display: unset;
    }
    .request-pto-list {
      width: 100%;
      padding: 0px;
      border: 1px solid #ced4da;
      height: 450px;
      overflow: auto;
      margin-bottom: 30px;
    }
    .res-view-title {
      display: block;
    }
  }

  .timesite-container :global(.actions-right) {
    flex-grow: 1;
    display:  flex;
    justify-content: flex-end;
    gap: 1rem;
  }

  input[name^=Checkbox_] {
    min-width: 1rem;
  }
</style>

<NavbarSuccess>
  <ul>
    <li>
      <a href="/timesheet">Timesheets</a>
    </li>
    <li style="background-color:  #304c63;">
      <a href="/ptoapproval">PTO Pending for Approval</a>
    </li>
  </ul>
</NavbarSuccess>
<div class="timesite-container">
  <div style="display: flex; justify-content: space-between; padding: 0px 30px 10px 30px;">
    <div class="actions-right">
    {#if canApproveOrDecline}
        <button class="btn-flat" disabled={!hasSelectedRow || isApproveInProgress} on:click={onApprove}>
          {#if isApproveInProgress}
            <span class="fa fa-circle-notch fa-spin"></span>
          {/if}
          Approve
        </button>
        <button class="btn-flat" disabled={!hasSelectedRow || isDeclineInProgress} on:click={onDecline}>
          {#if isDeclineInProgress}
            <span class="fa fa-circle-notch fa-spin"></span>
          {/if}
          Decline
        </button>
      {/if}
    </div>
  </div>
  <div class="request-row">
    {#await fetchDataAsync()}
      <DataSpinner />
    {:then}
      <div class="request-pto-list">
        <Table responsive bordered>
          <thead>
            <tr>
              <th>
                <span class="header-label">
                  &nbsp;
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('RequestDate')}>
                  Request Date
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('RequestDate', 'Request Date')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['RequestDate'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('EmployeeName')}>
                  Employee
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('EmployeeName', 'Employee')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['EmployeeName'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('TimeOffTypeLabel')}>
                  Timeoff Label
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('TimeOffTypeLabel', 'Timeoff Label')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['TimeOffTypeLabel'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('StartDate')}>
                  Start Date
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('StartDate', 'Start Date')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['StartDate'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('EndDate')}>
                  End Date
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('EndDate', 'End Date')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['EndDate'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('Notes')}>
                  Notes
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('Notes', 'Notes')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['Notes'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {#each displayedData as list}
              <tr>
                <td>
                  <input type="checkbox" name={`Checkbox_${list.EmployeePtoId}`} id={`checkbox_${list.EmployeePtoId}`}
                         bind:checked={selectedRows[list.EmployeePtoId]}>
                </td>
                <td>
                  <span class="res-view-title">Request Date</span>
                  {list.RequestDate === null ? 'N/A' : list.RequestDate}
                </td>
                <td>
                  <span class="res-view-title">Employee</span>
                  {list.EmployeeName}
                </td>
                <td>
                  <span class="res-view-title">Timeoff Label</span>
                  {list.TimeOffTypeLabel === null ? 'N/A' : list.TimeOffTypeLabel}
                </td>
                <td>
                  <span class="res-view-title">Start Date</span>
                  {list.StartDate === null ? 'N/A' : list.StartDate}
                </td>
                <td>
                  <span class="res-view-title">End Date</span>
                  {list.EndDate === null ? 'N/A' : list.EndDate}
                </td>
                <td>
                  <span class="res-view-title">Notes</span>
                  {list.Notes === null ? 'N/A' : list.Notes}
                </td>
              </tr>
            {/each}
          </tbody>
        </Table>
      </div>
    {/await}
  </div>
</div>

<ColumnFilterModal bind:this={columnFilterModal} on:filter={evt => updateFilters(evt.detail.field, evt.detail.value)}></ColumnFilterModal>

<Modal isOpen={isApproveConfirmOpen} toggle={() => (isApproveConfirmOpen = !isApproveConfirmOpen)} transition="fade">
  <ModalHeader toggle={() => (isApproveConfirmOpen = !isApproveConfirmOpen)}>PTO Approval</ModalHeader>
  <ModalBody>Approve selected PTOs?</ModalBody>
  <ModalFooter>
    {#if isApproveInProgress}
      <Button color="primary" style="cursor: not-allowed; opacity: 0.5" disabled>
        <Spinner size="sm" />
      </Button>
    {:else}
      <Button color="primary" on:click={onApproveConfirmed}>Confirm</Button>
    {/if}
    <Button color="secondary" on:click={() => (isApproveConfirmOpen = false)}>Cancel</Button>
  </ModalFooter>
</Modal>

<Modal isOpen={isDeclineConfirmOpen} toggle={() => (isDeclineConfirmOpen = !isDeclineConfirmOpen)} transition="fade">
  <ModalHeader toggle={() => (isDeclineConfirmOpen = !isDeclineConfirmOpen)}>PTO Approval</ModalHeader>
  <ModalBody>Decline selected PTOs?</ModalBody>
  <ModalFooter>
    {#if isDeclineInProgress}
      <Button color="primary" style="cursor: not-allowed; opacity: 0.5" disabled>
        <Spinner size="sm" />
      </Button>
    {:else}
      <Button color="primary" on:click={onDeclineConfirmed}>Confirm</Button>
    {/if}
    <Button color="secondary" on:click={() => (isDeclineConfirmOpen = false)}>Cancel</Button>
  </ModalFooter>
</Modal>

<Modal isOpen={isApproveDone} toggle={() => (isApproveDone = !isApproveDone)} transition="fade">
  <ModalHeader toggle={() => (isApproveDone = !isApproveDone)}>PTO Approval</ModalHeader>
  <ModalBody>{approveResponse}</ModalBody>
  <ModalFooter>
    <Button color="secondary" on:click={() => (isApproveDone = false)}>Ok</Button>
  </ModalFooter>
</Modal>

<Modal isOpen={isDeclineDone} toggle={() => (isDeclineDone = !isDeclineDone)} transition="fade">
  <ModalHeader toggle={() => (isDeclineDone = !isDeclineDone)}>PTO Approval</ModalHeader>
  <ModalBody>{declineResponse}</ModalBody>
  <ModalFooter>
    <Button color="secondary" on:click={() => (isDeclineDone = false)}>Ok</Button>
  </ModalFooter>
</Modal>
